// extracted by css-extract-rspack-plugin
export default {"searchFooterButton":"search-footer-button--U8TjXsfvkgUXAB79"};